export const TipoFechaMoraNota = [
    {
        nombreEnvio: "fechaIngresa",
        nombreProceso: "FECHA DE INGRESO"
    }, {
        nombreEnvio: "fechaEnviaSAT",
        nombreProceso: "FECHA DE ENVIO SAT"
    }, {
        nombreEnvio: "fechaDesmarcaSAT",
        nombreProceso: "FECHA DE DESMARCA"
    }];

export const nombreEnvio = (nombreProceso: string) => {
    return TipoFechaMoraNota.find(tipo => tipo.nombreProceso === nombreProceso);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_envio_mora/modelo/TipoFechaMoraNota.ts